import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Grid, Input, Button } from 'semantic-ui-react';
import ReadCookie from '../../functions/readcookies';
import Control from './control';
import Permission from '../../functions/permission';

class Executivebranch extends React.Component {

  state = {
    load: false,
    message: '',
    executiveBranch: [],
    allCustomer: [],
    allExecutive: [],
    mappedExecutive: [],
    executivebranchview: 'show', menuPermission: []
  }

  componentDidMount() {
    this.getPermission();
  }

  getPermission() {
    let menuPermission = Permission('customer-type-mapping', this.props.menus);
    if (menuPermission.view) {
      this.getCustomerType();
      this.setExecutiveCustomer();
    }
    this.setState({ menuPermission })
  }

  getCustomerType() {
    let context = this;
      $.ajax({
        type: 'POST',
        url: Server() + 'customertype/get.php',
        success: function(customerTypes) {
          let news = [];
          try {
            customerTypes = JSON.parse(customerTypes);
            customerTypes.map((c) => {
              news.push({ key: c.type_name, text: c.type_name, value: c.id })
            })
            context.setState({ allCustomerOption: news })
          } catch (error) {
            alert('Try Again!!!');
          }
        },
        error: function(e) {
          context.setState({ load: false });
        }
      });
  }


  setExecutiveCustomer() {
    let context = this;
    context.setState({ load: true, message: 'Getting Executive!!!' });
    let url = Server() + 'customerTypeMapping/get.php';
    $.ajax({
      type: 'POST', url,
      success: function(data) {
        let allExecutive = [];
        let mappedExecutive = [];
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.type == "employee") {
              allExecutive.push({ key: c.name, text: c.name, value: c.id })
            }
            else {
              mappedExecutive.push(c);
            }
          })
          context.setState({
            executiveBranch: data,
            mappedExecutive: mappedExecutive,
            allExecutive: allExecutive,
          })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  search = () => {
    let search = document.getElementById("search").value;
    this.setState({ search })
  }

  render() {
    let i = 0;
    let title = "Customer Type Mapping";
    return (
      <div>
        <Title title={title} openDrawer={this.props.openDrawer} />
          { this.state.menuPermission.view ?
            <div>
            <Loading load={this.state.load} message={this.state.message} />
            <Grid style={{display: this.state.executivebranchview}}>
              <Grid.Column mobile={16} tablet={16} computer={16}>
              <br/>
              { this.state.allExecutive.length > 0 ?
                (
                  <div style={{padding: '1.5%'}} id="scrollsss">
                    <br/>
                    <table width="100%" id="table">
                      <tr>
                        <th id='tableheader' style={{ width: '7%' }}>Sino<center></center></th>
                        <th id='tableheader' style={{ width: '30%' }}>Executive<center></center></th>
                        <th id='tableheader' style={{ width: '63%' }}>Customer Type<center></center></th>
                      </tr>
                      { this.state.allExecutive.map((z) => {
                          i++
                          let y = [];
                          let id = z.value;
                          return (
                            <tr>
                              <td><center>{i}</center></td>
                              <td>{z.key}</td>
                              <td>
                                { this.state.mappedExecutive.map((c) => {
                                    if (c.name == z.value) {
                                      y.push(c.id);
                                    }
                                  })
                                }
                                <Control eid={id} data={y}
                                  menuPermission={this.state.menuPermission}
                                  allCustomerOption={this.state.allCustomerOption}
                                  executivebranchedit={this.state.executivebranchedit}   />
                              </td>
                            </tr>
                           )
                        })
                      }
                    </table>
                  </div>
                ) :
                (
                  <div></div>
                )
              }
              </Grid.Column>
            </Grid>
          </div>:<center>You Are Not Allow To Access This Menu!!!</center>
        }
      </div>
    );
  }
}

export default Executivebranch;
